import React from 'react';
import { motion } from 'framer-motion';

// ─── CONFIGURACIÓN ────────────────────────────────────────────────────────────
// Reemplaza 'tumanodice-20' con tu tag de Amazon Associates
// Regístrate gratis en: https://associates.amazon.com
const AFFILIATE_TAG = 'tumanodice-20';

// Marketplace: cambia a 'amazon.es' (España) o 'amazon.com.mx' (México) según tu público
const AMAZON_DOMAIN = 'amazon.com';

function url(asin) {
  return `https://www.${AMAZON_DOMAIN}/dp/${asin}?tag=${AFFILIATE_TAG}`;
}

// ─── PRODUCTOS ────────────────────────────────────────────────────────────────
// Bestsellers estables en el nicho místico/espiritual de Amazon
const PRODUCTOS = [
  {
    asin:     'B000XUYNQM',
    emoji:    '🃏',
    nombre:   'Tarot Rider Waite',
    sub:      'El mazo más leído del mundo',
    color:    'rgba(255,215,0,0.12)',
    borde:    'rgba(255,215,0,0.4)'
  },
  {
    asin:     '1577151909',
    emoji:    '✋',
    nombre:   'The Art of Hand Reading',
    sub:      'Guía completa de quiromancia',
    color:    'rgba(147,112,219,0.12)',
    borde:    'rgba(147,112,219,0.4)'
  },
  {
    asin:     'B07V1G95H7',
    emoji:    '💎',
    nombre:   'Kit de Cristales Sanadores',
    sub:      '7 piedras de chakra + guía',
    color:    'rgba(233,69,96,0.10)',
    borde:    'rgba(233,69,96,0.35)'
  }
];

/**
 * Sección de afiliados de Amazon.
 * Se muestra al final de Resultado.js para todos los usuarios
 * (la colocación exacta se controla desde Resultado.js).
 */
function Afiliados() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 0.3 }}
      style={{ marginTop: '3rem', paddingTop: '2rem', borderTop: '1px solid rgba(255,215,0,0.15)' }}
    >
      {/* Cabecera */}
      <div style={{ textAlign: 'center', marginBottom: '1.4rem' }}>
        <p style={{ color: 'var(--color-oro)', fontStyle: 'italic', fontSize: '0.95rem', opacity: 0.85 }}>
          🌙 Selene ha dejado algo para ti
        </p>
        <p style={{ color: 'var(--color-texto-suave)', fontSize: '0.8rem', marginTop: '0.25rem' }}>
          Herramientas para seguir explorando tu camino
        </p>
      </div>

      {/* Grid de productos */}
      <div style={{ display: 'flex', gap: '0.8rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        {PRODUCTOS.map((p) => (
          <a
            key={p.asin}
            href={url(p.asin)}
            target="_blank"
            rel="noopener noreferrer sponsored"
            style={{
              flex: '1 1 140px',
              maxWidth: '180px',
              textDecoration: 'none',
              display: 'block'
            }}
          >
            <motion.div
              whileHover={{ scale: 1.04, y: -3 }}
              whileTap={{ scale: 0.97 }}
              transition={{ type: 'spring', stiffness: 300 }}
              style={{
                background: p.color,
                border: `1px solid ${p.borde}`,
                borderRadius: '14px',
                padding: '1.1rem 0.8rem',
                textAlign: 'center',
                cursor: 'pointer',
                height: '100%'
              }}
            >
              <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>{p.emoji}</div>
              <div style={{
                color: 'var(--color-texto)',
                fontWeight: '600',
                fontSize: '0.82rem',
                lineHeight: 1.3,
                marginBottom: '0.35rem'
              }}>
                {p.nombre}
              </div>
              <div style={{
                color: 'var(--color-texto-suave)',
                fontSize: '0.72rem',
                lineHeight: 1.3,
                marginBottom: '0.75rem'
              }}>
                {p.sub}
              </div>
              <div style={{
                display: 'inline-block',
                padding: '0.3rem 0.7rem',
                background: 'rgba(255,255,255,0.06)',
                border: `1px solid ${p.borde}`,
                borderRadius: '20px',
                color: 'var(--color-oro)',
                fontSize: '0.72rem',
                fontWeight: '600'
              }}>
                Ver en Amazon →
              </div>
            </motion.div>
          </a>
        ))}
      </div>

      {/* Disclaimer legal requerido por Amazon */}
      <p style={{
        textAlign: 'center',
        color: 'var(--color-texto-suave)',
        fontSize: '0.68rem',
        marginTop: '1rem',
        opacity: 0.55
      }}>
        Como Asociado de Amazon gano por compras calificadas.
      </p>
    </motion.div>
  );
}

export default Afiliados;
